export default __webpack_public_path__ + "static/media/7.7cf60256.png";